define((require) => {
    "use strict";

    const PreviewTemplateNavBarView                 = require("ui/viewer/PreviewTemplateNavBarView.tpl");
    const PreviewNavBarView                         = require("ui/viewer/PreviewNavBarView");
    const TemplateItemViewController                = require("ui/dashboard/TemplateItemViewController");

    /**
     * The nav bar view for template preview.
     *
     * @class PreviewTemplateNavBarView
     * @constructor
     *
     * @cfg {ExperienceViewModel} The experience view model.
     */
    return PreviewNavBarView.extend({

        template: PreviewTemplateNavBarView,

        controller: TemplateItemViewController,

        className: "nav-bar preview-nav-bar",

        keyboard: {
            // Overriding the extended method so it does nothing.
            escape: function() {}
        },

        bindings: {
            ".return-to-editor": {
                attributes: [{
                    observe: "currentScene",
                    name: "href",
                    onGet: function() {
                        return "#";
                    }
                }]
            }
        },

        ui: {
            createExperience: ".create-experience"
        },

        events: {
            "click @ui.createExperience": function() {
                this.trigger("duplicate", this.model.get("experience"), "TemplatePreview");
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/viewer/PreviewTemplateNavBarView.js